import React, { useState, useRef, useEffect } from 'react';
import { LoadScript, Autocomplete } from '@react-google-maps/api';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notify = (text) =>
  toast.error(text, {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

const libraries = ['places'];

const useGoogleMapsScript = (libraries = []) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (!existingScript) {
      setIsLoaded(true); // Set true when script is loaded successfully
    }
  }, []);

  return isLoaded;
};

const AddressField = ({ label, defaultValue, setFieldValue, handleBlur, errors, touched, name, handleChange, placeholder, onData, value,labelClasses = "", inputClasses = "", errorClasses="", hideLabel = false}) => {
  const [inputValue, setInputValue] = useState(defaultValue ?? '');
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const onLoad = autocomplete => {
    inputRef.current = autocomplete;
  };

  const extractLocation = (adrHtml) => {
    const getValue = (label) => {
      const match = adrHtml.match(new RegExp(`<span class="${label}">(.*?)</span>`));
      return match?.[1] || '';
    };
  
    return {
      region: getValue("region"),
      locality: getValue("locality"),
      streetAddress: getValue("street-address"),
      postalCode: getValue("postal-code"),
    };
  };
  

  const onPlaceChanged = () => {
    if (inputRef.current !== null) {
      const place = inputRef.current.getPlace();
      const adr = place?.adr_address || "";
  
      const { locality, streetAddress, postalCode } = extractLocation(adr);
  
      // Avoid empty ghost UI
      if (!streetAddress || !locality || !postalCode) {
        setInputValue(""); // UI
        setFieldValue(name, ""); // Formik
        setFieldValue("city", "");
        onData({ locality: "", postalCode: "", streetAddress: "" });
        notify("Incomplete address. Please pick a more specific address.");
        return;
      }
  
      // FULL SYNC here:
      setInputValue(streetAddress);
      setFieldValue(name, streetAddress);
      setFieldValue("city", locality);
      setFieldValue("postal_code", postalCode);
      onData({ locality, postalCode, streetAddress });
    }
  };
  

  const onChange = e => {
    setInputValue(e.target.value);
    handleChange(e);
  };

  useEffect(() => {
    if (value) {
      setInputValue(value);
    }
  }, [value]);
  

  const isLoaded = useGoogleMapsScript(['places']);

  if (isLoaded) {
    return (
      <LoadScript googleMapsApiKey="AIzaSyDmmvWXjMqA-kPlh-ebdp9H7MAq9MRuYb0" libraries={libraries}>
        <div className="relative">
          <label className={`text-sm md:text-md text-[#777] ${labelClasses}`}>
            {label}
            <small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
          </label>
          <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
            <input
              type="text"
              name={name}
              id={name}
              placeholder={placeholder}
              className={`min-h-[40px] md:min-h-[48px] w-full text-base md:text-md rounded border border-stone-300 bg-transparent py-[0.32rem] px-3 outline-none transition-all duration-200 ease-linear ${inputClasses}`}
              onBlur={handleBlur}
              value={inputValue}
              onChange={onChange}
            />
          </Autocomplete>
          {errors && touched && <small className={`text-[#f60362] text-sm ${errorClasses}`}>{errors}</small>}
        </div>
      </LoadScript>
    );
  }
  return (
    <div className="relative">
      {!hideLabel && (
        <label className={`text-sm md:text-md text-[#777] ${labelClasses}`}>
          {label}
          <small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
        </label>
      )}
      <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
        <input
          type="text"
          name={name}
          id={name}
          placeholder={placeholder}
          className={`min-h-[40px] md:min-h-[48px] w-full text-base md:text-md rounded border border-stone-300 bg-transparent py-[0.32rem] px-3 outline-none transition-all duration-200 ease-linear ${inputClasses}`}
          onBlur={handleBlur}
          value={inputValue}
          onChange={onChange}
        />
      </Autocomplete>
      {errors && touched && <small className={`text-[#f60362] text-sm ${errorClasses}`}>{errors}</small>}
    </div>
  );
};

export default AddressField;
